export class ConversionHelper {
  constructor() {}
  static convertMetersToMiles(meters: number): string {
    return (meters * 0.000621371192).toFixed(1);
  }

  static convertMetersToKilometers(meters: number): string {
    return (meters / 1000).toFixed(1);
  }
}
